export const DAILY_REPORT_DVISION_SUPERVISER = 1;
export const DAILY_REPORT_DVISION_OUTSOURCE = 2;

export const DAILY_REPORT_DVISION = [
  {
    code: DAILY_REPORT_DVISION_SUPERVISER,
    name: '現場管理'
  },
  {
    code: DAILY_REPORT_DVISION_OUTSOURCE,
    name: '職人'
  }
];

// 整数項目のバリデーション
export const UNSIGNED_INT_VALIDATION = /^([1-9]\d*|0)$/;
export const UNSIGNED_INT_VALIDATION_MSG = '0以上の整数を入力してください';

// 日報の写真アップロード制限
export const MAX_IMAGE_MB = 10;
export const MAX_IMAGE_SIZE = 1024 * 1024 * MAX_IMAGE_MB;
export const MAX_IMAGE_COUNT = 10;
